<div id="analytics-container">
    <div id="card-container" *loading="courseDataStatus">
      <mat-card *ngFor="let stat of statsCards" class="stat-card">
        <stat-card [icon]="stat.icon" [label]="stat.label" [sublabel]="stat.sublabel"></stat-card>
      </mat-card>
    </div>
  
    <div class="chart-row">
      <mat-card id="traffic-chart-container" >
        <mat-card-title class="card-title">
          <div class="title">Traffic</div>
        </mat-card-title>
        <mat-card-content *loading="trafficDataStatus">
            <google-chart *ngIf="trafficChart" [data]="trafficChart"></google-chart>
        </mat-card-content>
      </mat-card>
      <mat-card id="last-session-chart-container" >
        <mat-card-title class="card-title">
          <div class="title">Latest Sessions</div>
          <div class="link" (click)="goToSessionTab()"><span>> more</span></div>
        </mat-card-title>
        <mat-card-content *loading="latestSessionDataStatus">
            <latest-sessions-widget *ngIf="latestSessionsData" [sessions]="latestSessionsData" (onSearch)="showUserSessions($event)"></latest-sessions-widget>
        </mat-card-content>
      </mat-card>
    </div>
<div class="chart-row">
  <mat-card id="content-chart-container" >
    <mat-card-title class="card-title">
      <div class="title">Views per Content</div>
      <div class="link" (click)="goToContentTab()"><span>> more</span></div>
    </mat-card-title>
    <mat-card-content *loading="contentDataStatus">
        <google-chart *ngIf="contentChart" [data]="contentChart"></google-chart>
    </mat-card-content>
  </mat-card>
</div>


  <div id="platform-charts-container" class="chart-row" >
    <mat-card class="chart-card" *loading="browserDataStatus">
      <mat-card-title> Top Browsers</mat-card-title>
      <mat-card-content>
        <google-chart *ngIf="browserChart" [data]="browserChart" ></google-chart>
      </mat-card-content>
    </mat-card>
    <mat-card class="chart-card" *loading="osDataStatus">
      <mat-card-title>
        Top OS
      </mat-card-title>
      <mat-card-content>
          <google-chart *ngIf="osChart" [data]="osChart" ></google-chart>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="chart-row">
    <mat-card id="source-chart-container" *loading="sourceDataStatus">
      <mat-card-title>
          Top Traffic Sources
      </mat-card-title>
      <mat-card-content>
          <google-chart *ngIf="sourceChart" [data]="sourceChart" ></google-chart>
      </mat-card-content>
  </mat-card>
  </div>
</div>